import React from 'react';
import UserDashboard from '../../UserDashboard';



export default function Perks () {
    return (
        <UserDashboard>
            <div></div>
        </UserDashboard>
    )
}